import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { QuestionMarkCircleIcon } from '@heroicons/react/solid';
import convertJsonToHtml from '../../../utils/convertJsonToHtml';

function OpenQuestion(props) {
  const { item } = props;
  const [submitted, setSubmitted] = useState(false);
  const [answer, setAnswer] = useState('');
  const { t } = useTranslation();

  return (
    <div className="w-full flex justify-center">
      <div className="flex flex-col space-y-5 max-w-xl mt-8 w-full rounded-lg shadow-md bg-white p-5">
        {/* Icon */}
        <div className="my-3 bg-gradient-to-br from-purple-500 via-sky-light to-sky-dark rounded-md shadow-md w-min text-white p-3">
          <QuestionMarkCircleIcon className="w-8" />
        </div>
        {convertJsonToHtml(item.content.question)}

        {/* Show toelichting if available */}
        {item.content.explanation && (
          <p>
            <p>Toelichting</p>
            {convertJsonToHtml(item.content.explanation)}
          </p>
        )}

        {/* Answer field */}
        <span className="flex-col space-y-2">
          <textarea
            className="w-full rounded-md border-none outline-none bg-grey-super_light"
            rows={5}
            placeholder={t('courses.enter_answer_here')}
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
          />
        </span>

        {/* Show explanation when answer submitted */}
        {submitted ? (
          convertJsonToHtml(item.content.answer)
        ) : (
          <button
            type="button"
            className="bg-sky text-white rounded-md px-4 py-2 hover:bg-sky-dark float-right"
            onClick={() => setSubmitted(true)}
          >
            {t('courses.confirm_answer')}
          </button>
        )}
      </div>
    </div>
  );
}

OpenQuestion.propTypes = {
  item: PropTypes.objectOf({
    content: PropTypes.objectOf({
      question: PropTypes.string.isRequired,
      explanation: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default OpenQuestion;
